import { useMemo } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui';

type Props = {
  currentMonth: Date;
  minDate: Date;
  maxDate: Date;
  onChange: (year: number) => void;
};

export function YearSelect({ currentMonth, minDate, maxDate, onChange }: Props) {
  const years = useMemo(() => {
    const min = minDate.getFullYear();
    const max = maxDate.getFullYear();
    return Array.from({ length: max - min + 1 }, (_, i) => max - i);
  }, [minDate, maxDate]);

  return (
    <Select
      value={String(currentMonth.getFullYear())}
      onValueChange={v => onChange(Number(v))}>
      <SelectTrigger
        size="default"
        withChevron
        placeholder=""
        className="w-auto min-w-[9rem] cursor-pointer gap-[0.4rem] pl-[1.6rem] pr-[1.2rem] transition-colors focus-visible:ring-0 focus-visible:border-transparent hover:bg-stroke-bg data-[state=open]:bg-stroke-bg [&>svg]:text-secondary">
        <span className="headline4 text-primary">
          <SelectValue />
        </span>
      </SelectTrigger>
      <SelectContent
        className="max-h-[32rem] w-auto max-w-none min-w-[var(--radix-select-trigger-width)] rounded-[1.6rem]"
        classNameViewport="w-auto min-w-full max-w-none">
        {years.map(year => (
          <SelectItem
            key={year}
            value={String(year)}
            showOptionCheckmark={false}
            className="headline4 cursor-pointer py-[1.4rem] px-[2.4rem]">
            {year}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
